import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from "@themesberg/react-bootstrap";

import { UpdatePassword, reset } from "../../../features/profileSlice";
import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import { showSuccessDialog } from "../../../helpers/dialog.helper";

const ProfilePassword = () => {
  const [isLocked, setIsLocked] = useState(true);
  const [newData, setNewData] = useState({
    password: "",
    newPassword: "",
  });
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const { isLoading, isError, message } = useSelector((state) => state.profile);

  useEffect(() => {
    setNewData({
      password: "",
      newPassword: "",
    });
    dispatch(reset());
  }, [isLocked, dispatch]);

  const afterUpdatePassword = (result) => {
    setIsLocked(true);
    
    // update token
    localStorage.setItem(
      "userData",
      JSON.stringify({ status: result?.data?.status, id: result?.data?.id })
    );
    localStorage.setItem("token", result?.jwt_token);

    showSuccessDialog({
      title: "Berhasil!",
      msg: result?.message || "Berhasil mengupdate password!",
    });
    dispatch(reset());
    window.location.href = "/profile";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      UpdatePassword({
        token,
        password: newData.password,
        newPassword: newData.newPassword,
        cb: afterUpdatePassword,
      })
    );
  };

  return (
    <AdminLayout>
      <Header>
        <Button onClick={() => setIsLocked(!isLocked)}>
          {isLocked ? "Edit" : "Kembali"}
        </Button>
      </Header>

      <Card>
        <Card.Body>
          {isError && message ? (
            <Alert variant="danger">
              {message?.message || message?.errors[0].msg}
            </Alert>
          ) : null}
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group id="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    required
                    disabled={isLocked}
                    type="password"
                    placeholder="Password lama"
                    name="password"
                    value={newData.password || ""}
                    onChange={(e) =>
                      setNewData({ ...newData, password: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="newPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    required
                    disabled={isLocked}
                    type="password"
                    placeholder="Password baru"
                    name="newPassword"
                    value={newData.newPassword || ""}
                    onChange={(e) =>
                      setNewData({ ...newData, newPassword: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <div>
              {!isLocked ? (
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? "Loading..." : "Update"}
                </Button>
              ) : null}
            </div>
          </Form>
        </Card.Body>
      </Card>
    </AdminLayout>
  );
};

export default ProfilePassword;
